import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import { normalizeSearchText } from '../../common/utils/normalize';
export default class GorbeaPronosticosDetailModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "titleText", void 0);
    // For 'team' type
    _defineProperty(this, "team", null);
    // For 'question' type
    _defineProperty(this, "questionLabel", void 0);
    // General
    _defineProperty(this, "votes", []);
    _defineProperty(this, "rivals", []);
    _defineProperty(this, "players", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.type = this.attrs.type;
    this.votes = this.attrs.votes || [];
    this.rivals = this.attrs.rivals || [];
    this.players = this.attrs.players || [];
    if (this.type === 'team') {
      this.team = this.attrs.team;
      this.titleText = "Pron\xF3sticos para ".concat(this.team.attribute('name') || 'Equipo');
    } else {
      this.questionLabel = this.attrs.questionLabel;
      this.titleText = "Detalle: ".concat(this.questionLabel);
    }
  }
  className() {
    return 'GorbeaPronosticosDetailModal Modal--medium';
  }
  title() {
    return this.titleText;
  }
  content() {
    if (this.type === 'team') {
      return this.renderTeamDetail();
    } else {
      return this.renderQuestionDetail();
    }
  }
  renderTeamDetail() {
    const teamId = String(this.team.id());

    // Group users by the position they predicted for this team
    const posGroups = {};
    for (let i = 1; i <= 20; i++) {
      posGroups[i] = [];
    }
    this.votes.forEach(vote => {
      const user = vote.user();
      if (!user || !vote.attribute('classification')) return;
      const classification = vote.attribute('classification') || [];
      const posIndex = classification.indexOf(teamId);
      if (posIndex !== -1) {
        const pos = posIndex + 1;
        posGroups[pos].push(user);
      }
    });

    // Filter to positions that have at least one user
    const activePositions = Object.keys(posGroups).map(Number).filter(pos => posGroups[pos].length > 0).sort((a, b) => a - b);
    return m("div", {
      className: "Modal-body GorbeaPronosticosDetail-body"
    }, m("div", {
      className: "GorbeaPronosticosDetail-intro",
      style: "margin-bottom: 20px; display: flex; align-items: center; gap: 12px;"
    }, this.team.escudo() && m("img", {
      src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(this.team.escudo()),
      alt: this.team.attribute('name'),
      style: "width: 40px; height: 40px; object-fit: contain;"
    }), m("p", {
      style: "margin: 0;"
    }, "Posiciones pronosticadas por los foreros para el ", m("strong", null, this.team.attribute('name')), ":")), m("div", {
      className: "GorbeaPronosticosDetail-list",
      style: "display: flex; flex-direction: column; gap: 15px;"
    }, activePositions.map(pos => {
      const users = posGroups[pos];
      return m("div", {
        className: "GorbeaPronosticosDetail-group",
        style: "border-bottom: 1px solid var(--control-bg); padding-bottom: 12px;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px; margin-bottom: 8px;"
      }, m("span", {
        className: "badge",
        style: "font-size: 15px; font-weight: bold; background: var(--primary-color); color: #fff; padding: 4px 10px; border-radius: 4px;"
      }, pos, "\xBA posici\xF3n"), m("span", {
        style: "color: var(--muted-color); font-size: 12px;"
      }, "(", users.length, " ", users.length === 1 ? 'forero' : 'foreros', ")")), m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 10px; padding-left: 10px;"
      }, users.map(user => m(Link, {
        href: app.route('user', {
          username: user.username()
        }),
        className: "GorbeaPronosticosDetail-user",
        style: "display: flex; align-items: center; gap: 6px; padding: 4px 8px; border-radius: 20px; background: var(--control-bg); color: var(--text-color); font-size: 13px; text-decoration: none;"
      }, avatar(user, {
        style: 'width: 20px; height: 20px; font-size: 9px; line-height: 20px;'
      }), m("span", null, username(user))))));
    })));
  }
  renderQuestionDetail() {
    const questionKey = this.attrs.questionKey;

    // Group votes by answers
    const answerGroups = {};
    this.votes.forEach(vote => {
      const user = vote.user();
      if (!user) return;
      const answer = vote.attribute(questionKey);
      if (answer !== undefined && answer !== null && String(answer).trim() !== '') {
        const answerStr = String(answer).trim();
        if (!answerGroups[answerStr]) {
          answerGroups[answerStr] = [];
        }
        answerGroups[answerStr].push(user);
      }
    });

    // Sort answers by number of responses descending
    const sortedAnswers = Object.keys(answerGroups).sort((a, b) => {
      return answerGroups[b].length - answerGroups[a].length;
    });
    return m("div", {
      className: "Modal-body GorbeaPronosticosDetail-body"
    }, m("div", {
      className: "GorbeaPronosticosDetail-intro",
      style: "margin-bottom: 20px;"
    }, m("p", null, "Respuestas detalladas para la pregunta: ", m("strong", null, this.questionLabel))), m("div", {
      className: "GorbeaPronosticosDetail-list",
      style: "display: flex; flex-direction: column; gap: 15px;"
    }, sortedAnswers.length === 0 ? m("p", {
      style: "text-align: center; color: var(--muted-color); padding: 20px 0;"
    }, "No hay respuestas registradas a\xFAn.") : sortedAnswers.map(answer => {
      const users = answerGroups[answer];
      return m("div", {
        className: "GorbeaPronosticosDetail-group",
        style: "border-bottom: 1px solid var(--control-bg); padding-bottom: 12px;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px; margin-bottom: 8px;"
      }, (() => {
        const cleanAnswer = normalizeSearchText(answer);

        // 1. Try to match team
        const matchingRival = this.rivals.find(r => {
          const rName = normalizeSearchText(r.attribute('name'));
          return cleanAnswer === rName || cleanAnswer.includes(rName) || rName.includes(cleanAnswer);
        });
        if (matchingRival && matchingRival.escudo()) {
          return m("img", {
            src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(matchingRival.escudo()),
            alt: answer,
            style: "width: 24px; height: 24px; object-fit: contain; flex-shrink: 0;"
          });
        }

        // 2. Try to match player
        const matchingPlayer = this.players.find(p => {
          if (String(p.id()) === cleanAnswer) return true;
          const pName = normalizeSearchText(p.name());
          if (cleanAnswer === pName || cleanAnswer.includes(pName) || pName.includes(cleanAnswer)) return true;
          const aliases = (p.aliases() || '').split(',').map(a => normalizeSearchText(a)).filter(Boolean);
          return aliases.some(a => a && (cleanAnswer === a || cleanAnswer.includes(a) || a.includes(cleanAnswer)));
        });
        if (matchingPlayer && matchingPlayer.photoUrl()) {
          return m("img", {
            src: matchingPlayer.photoUrl(),
            alt: answer,
            style: "width: 24px; height: 24px; border-radius: 50%; object-fit: cover; flex-shrink: 0; border: 1px solid rgba(0,0,0,0.1);"
          });
        }
        return null;
      })(), (() => {
        const cleanAnswer = normalizeSearchText(answer);
        const matchingPlayer = this.players.find(p => {
          if (String(p.id()) === cleanAnswer) return true;
          const pName = normalizeSearchText(p.name());
          return cleanAnswer === pName || cleanAnswer.includes(pName) || pName.includes(cleanAnswer);
        });
        return m("span", {
          className: "badge",
          style: "font-size: 14px; font-weight: bold; background: var(--control-bg); border: 1px solid var(--muted-color); padding: 4px 10px; border-radius: 4px;"
        }, matchingPlayer ? matchingPlayer.name() : answer);
      })(), m("span", {
        style: "color: var(--muted-color); font-size: 12px;"
      }, "(", users.length, " ", users.length === 1 ? 'respuesta' : 'respuestas', ")")), m("div", {
        style: "display: flex; flex-wrap: wrap; gap: 10px; padding-left: 10px;"
      }, users.map(user => m(Link, {
        href: app.route('user', {
          username: user.username()
        }),
        className: "GorbeaPronosticosDetail-user",
        style: "display: flex; align-items: center; gap: 6px; padding: 4px 8px; border-radius: 20px; background: var(--control-bg); color: var(--text-color); font-size: 13px; text-decoration: none;"
      }, avatar(user, {
        style: 'width: 20px; height: 20px; font-size: 9px; line-height: 20px;'
      }), m("span", null, username(user))))));
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/GorbeaPronosticosDetailModal', GorbeaPronosticosDetailModal);